import React from 'react'
import { IonIcon, IonItem, IonLabel, IonRow, IonCol } from '@ionic/react'
import { chevronForward } from 'ionicons/icons'
import { IPulsaraRecord } from '../../store/pulsara.types'
import { formatDateTime } from '../../../../utilities/dateTime.util'
import './PulsaraListItem.component.css'

export interface IPulsaraListItemProps {
  item: IPulsaraRecord
  onItemClick?: (id: string | number) => void
}

const PulsaraListItem: React.FC<IPulsaraListItemProps> = ({ item, onItemClick }) => {
  const handleClick = () => {
    if (onItemClick) {
      onItemClick(item.id)
    }
  }

  return (
    <IonItem button detail={false} onClick={handleClick} data-testid={`pulsara-item-${item.id}`}>
      <IonRow className='w-100 pulsara-list-item ion-no-padding'>
        <IonCol className='ion-no-padding d-flex w-100 justify-between'>
          <IonRow className='d-block'>
            <h2 className='pulsara-list-item-name mb-0'>
              {item.firstName} {item.lastName}
            </h2>
            <IonLabel color='medium' className='fw-400 font-size-13'>
              {item.createdAt ? formatDateTime(item.createdAt) : ''}
            </IonLabel>
          </IonRow>

          <IonLabel color='medium' className='category-label'>
            {item.caseType}
            <IonIcon icon={chevronForward} className='pulsara-list-item-chevron' color='medium' />
          </IonLabel>
        </IonCol>
      </IonRow>
    </IonItem>
  )
}

export default PulsaraListItem
